import React from "react";

const ITEMS = [
  "MILLION THREADS",
  "PREMIUM FABRIC",
  "LIMITED DROPS",
  "DESIGNED FOR THE FUTURE",
  "WEAR THE FUTURE",
  "DROP 01",
  "A MILLION STORIES",
  "EVERY THREAD HAS A STORY",
  "WORN BY FEW",
];

function Row() {
  return (
    <span className="inline-flex items-center flex-shrink-0">
      {ITEMS.map((t, i) => (
        <span key={i} className="inline-flex items-center px-7 font-mono text-[0.78rem] tracking-mt uppercase">
          <span>{t}</span>
          <span
            aria-hidden="true"
            className="mx-7 inline-block h-1 w-1 rounded-full"
            style={{
              background: "#555555",
            }}
          />
        </span>
      ))}
    </span>
  );
}

export default function Ticker({ variant = "default" }) {
  return (
    <div
      className="relative w-full border-x-0 mt-rainbow-edge mt-ticker-wrap"
      style={{ borderRadius: 0 }}
      data-testid={variant === "quote" ? "quote-strip" : "hero-ticker"}
    >
      <div className="py-5 w-full">
        <div className="mt-ticker-track mt-keep-anim">
          <Row />
          <Row />
          <Row />
        </div>
      </div>
    </div>
  );
}

export function QuoteStrip({ quote, testId = "quote-strip" }) {
  return (
    <div
     className="relative w-full border-x-0 mt-rainbow-edge mt-ticker-wrap"
      style={{ borderRadius: 0 }}
      data-testid={testId}
    >
      <div className="py-7 w-full">
        <div className="mt-ticker-track mt-keep-anim" style={{ animationDuration: "28s" }}>
          {Array(6).fill(0).map((_, r) => (
            <span key={r} className="inline-flex items-center flex-shrink-0">
              <span
                className="inline-flex items-center font-display font-light italic text-[1.1rem] sm:text-[1.35rem]"
                style={{ letterSpacing: "0.06em", padding: "0 5rem", whiteSpace: "nowrap" }}
              >
                <span style={{ color: "var(--mt-text-muted)" }}>—&nbsp;&nbsp;</span>
                <span style={{ color: "var(--mt-text)" }}>{quote}</span>
                <span style={{ color: "var(--mt-text-muted)" }}>&nbsp;&nbsp;—</span>
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ChromeDivider() {
  return (
    <div className="mt-container py-12 flex items-center gap-5" data-testid="chrome-divider">
      <span className="mt-divider-line flex-1 mt-keep-anim" />
      <span
        aria-hidden="true"
        className="block w-2 h-2 rotate-45"
        style={{
          background: "linear-gradient(135deg, #fff, #c8c8d0)",
          boxShadow: "0 0 12px rgba(0,170,255,0.55)",
        }}
      />
      <span className="mt-divider-line flex-1 mt-keep-anim" />
    </div>
  );
}
